import React, { ReactElement } from 'react'

import Field from '../../../../../../../1stlog-ui/src/components/Field'
import { mustBePhoneNumber } from '../../../../../../../1stlog-ui/src/components/Field/Validation'
import Input from '../../../../../../../1stlog-ui/src/components/Input'

type AdditionalPhoneProps = {}

export const AdditionalPhone = (props: AdditionalPhoneProps): ReactElement => {
  const {} = props

  return (
    <>
      <Field
        name="phone"
        label={i18n.t('additional_phone', 'Zusätzliche Telefonnummer')}
        validate={mustBePhoneNumber}
      >
        <Input
          type="phone"
          placeholder={i18n.t('enter_phone', 'Telefonnummer angeben')}
        />
      </Field>
    </>
  )
}
